// The precompiler doesn't put them in both places (the old maven one did and so we need this)
Handlebars.templates = Handlebars.partials;